/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseProductTilesFragment, ProductTilesFragment, FullProductTilesFragment} from '@amblique/contentful/app/contentful/fragments/product-tiles';

/**
 * Get a single ProductTiles by ID (base - scalars only)
 */
export const getBaseProductTilesById = gql`
  ${BaseProductTilesFragment}

  query GetBaseProductTilesById($id: String!, $locale: String!, $preview: Boolean) {
    productTiles(id: $id, locale: $locale, preview: $preview) {
      ...BaseProductTilesFragment
    }
  }
`;

/**
 * Get a single ProductTiles by ID (standard - 1 level deep)
 */
export const getProductTilesById = gql`
  ${ProductTilesFragment}

  query GetProductTilesById($id: String!, $locale: String!, $preview: Boolean) {
    productTiles(id: $id, locale: $locale, preview: $preview) {
      ...ProductTilesFragment
    }
  }
`;

/**
 * Get a single ProductTiles by ID (full - 2 levels deep)
 */
export const getFullProductTilesById = gql`
  ${FullProductTilesFragment}

  query GetFullProductTilesById($id: String!, $locale: String!, $preview: Boolean) {
    productTiles(id: $id, locale: $locale, preview: $preview) {
      ...FullProductTilesFragment
    }
  }
`;

/**
 * Get all ProductTiles entries with pagination (base - scalars only)
 */
export const getBaseProductTiless = gql`
  ${BaseProductTilesFragment}

  query GetBaseProductTiless(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ProductTilesOrder]
    $where: ProductTilesFilter
    $preview: Boolean
  ) {
    productTilesCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseProductTilesFragment
      }
    }
  }
`;

/**
 * Get all ProductTiles entries with pagination (standard - 1 level deep)
 */
export const getProductTiless = gql`
  ${ProductTilesFragment}

  query GetProductTiless(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ProductTilesOrder]
    $where: ProductTilesFilter
    $preview: Boolean
  ) {
    productTilesCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...ProductTilesFragment
      }
    }
  }
`;

/**
 * Get all ProductTiles entries with pagination (full - 2 levels deep)
 */
export const getFullProductTiless = gql`
  ${FullProductTilesFragment}

  query GetFullProductTiless(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ProductTilesOrder]
    $where: ProductTilesFilter
    $preview: Boolean
  ) {
    productTilesCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullProductTilesFragment
      }
    }
  }
`;
